import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedSearchButton } from './SearchButton';
import { withClickTrack } from '../../utils/HtmlEvents';
import buttonClassNames from './buttonClassNames';

const SearchButtonSpinner = () => (
    <span className="prisma-btn-spinner">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
    </span>
);

const SearchButton = withClickTrack(({ children, disabled, onClick, testId, htmlEventID, className }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            type="button"
            className={className}
            test-id={testId}
            data-testid={testId}
            html-event-id={htmlEventID}
        >
            {children}
        </button>
    );
});

export const SearchButtonStyled = ({
    astId, version, block, children, disabled, dynPack, extraTracking, hotelPrime, testId, htmlEventID, hotelStandalone, onErrorCallback
}) => (
    <ConnectedSearchButton
        extraTracking={extraTracking}
        dynPack={dynPack}
        hotelPrime={hotelPrime}
        astId={astId}
        hotelStandalone={hotelStandalone}
        onErrorCallback={onErrorCallback}
        render={({ loading, onClick }) => (
            <SearchButton
                onClick={onClick}
                disabled={disabled || loading}
                className={buttonClassNames(version, block, loading)}
                testId={testId}
                html-event-id={htmlEventID}
            >
                {children}
                {loading && <SearchButtonSpinner />}
            </SearchButton>
        )}
    />
);

SearchButtonStyled.propTypes = {
    astId: PropTypes.string,
    version: PropTypes.string,
    block: PropTypes.bool,
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    dynPack: PropTypes.bool,
    extraTracking: PropTypes.func,
    hotelPrime: PropTypes.bool,
    hotelStandalone: PropTypes.bool,
    testId: PropTypes.string,
    onErrorCallback: PropTypes.func,
};

SearchButtonStyled.defaultProps = {
    astId: null,
    version: 'primary',
    block: false,
    disabled: false,
    dynPack: false,
    hotelPrime: false,
    hotelStandalone: false,
    extraTracking: ()=>{},
    testId: 'search-btn',
    onErrorCallback: ()=>{},
};
